import { logoutApi, checkLoginStatusApi } from '../api/login';

const eventOn = emitter => {
  emitter.promiseOn('logout', params => {
    const { all_devices } = params;
    // 推出清空本地存储的消息gptSummaryMsgIds
    localStorage.removeItem('gptSummaryMsgIds');
    return logoutApi(all_devices);
  });

  emitter.promiseOn('checkLoginStatus', () => {
    return checkLoginStatusApi();
  });
};

export default eventOn;
